import React, { FC } from 'react';
import styles from './ThemePallete.scss';
import { getColorContrast, rgbToHex } from 'utils/colors';

type Props = {
  colors: string[];
  title: string;
  description: string;
};

export const ThemePallete: FC<Props> = ({ colors, title, description }) => {
  const [mainColor, ...restColors] = colors;
  const mainColorContrast = getColorContrast(mainColor);

  return (
    <div className={styles.themePallete} style={{ backgroundColor: mainColor }}>
      <div className={styles.themePalleteContent} style={{ color: mainColorContrast === 'light' ? '#000' : '#fff' }}>
        <p className={styles.themePalleteContentTitle}>{title}</p>
        <p className={styles.themePalleteContentDescription}>{description}</p>
      </div>
      <div className={styles.themePalleteColors}>
        {restColors.map((color) => {
          const contrast = getColorContrast(color);
          return (
            <div key={color} className={styles.themePalleteColorsItem} style={{ backgroundColor: color }}>
              <p style={{ color: contrast === 'light' ? '#000' : '#fff' }}>{rgbToHex(color)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
